import { ItemLabelModel } from '../../components/dropdown/models/dropdown-props.model';
import { ApkFileMetadataDto } from '../../dtos/apk-file-metadata.dto';
import { CategoryDto } from '../../dtos/category.dto';
import { CountryRegionDto } from '../../dtos/country-region.dto';
import { FileMetadataDto } from '../../dtos/file-metadata.dto';
import { LanguageDto } from '../../dtos/language.dto';
import { PlatformDto } from '../../dtos/platform.dto';
import { FeaturedEnum } from '../../enums/featured.enum';
import { StatesEnum } from '../../enums/states.enum';
import { CountryRegionModel } from '../../models/country-region.model';
import { FileMetadataModel } from '../../models/file-metadata.model';
import { IdFile } from '../../models/id-file.model';
import { LanguageModel } from '../../models/language.model';
import { PlatformModel } from '../../models/platform.model';

export function mapCountryRegionDtoToCountryRegionModel({
  id,
  name,
}: CountryRegionDto): CountryRegionModel {
  return {
    id,
    name,
  };
}

export function mapLanguageDtoToLanguageModel({
  iso,
  name,
}: LanguageDto): LanguageModel {
  return {
    iso,
    name,
  };
}

export function mapLanguageDtoToItemLabelModel({
  iso,
  name,
}: LanguageDto): ItemLabelModel<string> {
  return {
    id: iso,
    label: name,
  };
}

export function mapCategoryDtoToItemLabelModel({
  id,
  name,
}: CategoryDto): ItemLabelModel<number> {
  return {
    id: id,
    label: name,
  };
}

export function mapCountryRegionDtoToItemLabelModel({
  id,
  name,
}: CountryRegionDto): ItemLabelModel<number> {
  return {
    id: id,
    label: name,
  };
}

export function mapPlatformDtoToItemLabelModel({
  id,
  name,
  version,
}: PlatformDto): ItemLabelModel<number> {
  return {
    id: id,
    label: `${name} ${version}`,
  };
}

export function mapPlatformModelToItemLabelModel({
  id,
  name,
  version,
}: PlatformModel): ItemLabelModel<number> {
  return {
    id: id,
    label: `${name} ${version}`,
  };
}

export function mapFileMetadataModelToIdFile({
  id,
  name,
}: FileMetadataModel): IdFile {
  return {
    id: id,
    file: new File([], `${name}`),
  };
}

export function mapStatesEnumToItemLabelModel(
  state: StatesEnum
): ItemLabelModel {
  return {
    id: Object.keys(StatesEnum).indexOf(state),
    label: state,
  };
}

export function mapPlatformDtoToPlatformModel({
  id,
  name,
  version,
}: PlatformDto): PlatformModel {
  return {
    id,
    name,
    version,
  };
}

export function mapPlatformModelToPlatformDto({
  id,
  name,
  version,
}: PlatformModel): PlatformDto {
  return {
    id,
    name,
    version,
  };
}

export function mapFileMetadataDtoToFileMetadataModel({
  downloadLink,
  extension,
  id,
  name,
  type,
  versionCode,
  versionName,
  sizeInBytes,
  platforms,
}: FileMetadataDto): FileMetadataModel {
  return {
    downloadLink,
    extension,
    id,
    name,
    type,
    versionCode,
    versionName,
    sizeInBytes,
    platforms: platforms?.map(mapPlatformDtoToPlatformModel),
  };
}

export function mapApkFileMetadataDtoToFileMetadataModel({
  id,
  downloadLink,
  extension,
  name,
  type,
  versionCode,
  versionName,
  sizeInBytes,
  platforms,
}: ApkFileMetadataDto): FileMetadataModel {
  return {
    downloadLink,
    extension,
    id,
    name,
    type,
    versionCode,
    versionName,
    sizeInBytes,
    platforms: platforms?.map(mapPlatformDtoToPlatformModel) ?? [],
  };
}

export function mapFileMetadataModeltoFileMetadataDto({
  downloadLink,
  extension,
  id,
  name,
  type,
  versionCode,
  versionName,
  sizeInBytes,
  platforms,
}: FileMetadataModel): FileMetadataDto {
  return {
    downloadLink,
    extension,
    id,
    name,
    type,
    versionCode,
    versionName,
    sizeInBytes,
    platforms: platforms.map(mapPlatformModelToPlatformDto),
  };
}

export function mapFeatureEnumToItemLabelModel(
  feature: FeaturedEnum
): ItemLabelModel {
  return {
    id: feature,
    label: FeaturedEnum[feature],
  };
}
